import { render, staticRenderFns } from "./news-classify.vue?vue&type=template&id=0287ef76&scoped=true&"
import script from "./news-classify.vue?vue&type=script&lang=ts&"
export * from "./news-classify.vue?vue&type=script&lang=ts&"
import style0 from "./news-classify.vue?vue&type=style&index=0&id=0287ef76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0287ef76",
  null
  
)

export default component.exports